/*
 * Public API Surface of fasten-design-kit
 */

export { FDK_VERSION } from './lib/version';
export {
  FdkAlertComponent,
  type FdkAlertVariant,
} from './lib/alert/alert.component';
export {
  FdkButtonComponent,
  type FdkButtonType,
  type FdkButtonVariant,
  type FdkButtonWidth,
} from './lib/button/button.component';
export {
  FdkCardComponent,
  type FdkCardVariant,
} from './lib/card/card.component';
export {
  FdkCheckboxComponent,
} from './lib/checkbox/checkbox.component';
export {
  FdkDialogComponent,
} from './lib/dialog/dialog.component';
export {
  FdkDialogActionsComponent,
} from './lib/dialog-actions/dialog-actions.component';
export {
  FdkDialogContentComponent,
} from './lib/dialog-content/dialog-content.component';
export {
  FdkDialogTitleComponent,
} from './lib/dialog-title/dialog-title.component';
export {
  FdkFooterComponent,
} from './lib/footer/footer.component';
export {
  FdkHeaderComponent,
} from './lib/header/header.component';
export {
  FdkIconComponent,
  type FdkIconSize,
} from './lib/icon/icon.component';
export {
  FDK_ICON_NAMES,
  type FdkIconName,
} from './lib/icon/icon.types';
export {
  FdkIconButtonComponent,
  type FdkIconButtonVariant,
} from './lib/icon-button/icon-button.component';
export {
  FdkInputComponent,
  type FdkInputType,
} from './lib/input/input.component';
export {
  FdkInitialsComponent,
  type FdkInitialsSize,
} from './lib/initials/initials.component';
export {
  FdkLinkComponent,
} from './lib/link/link.component';
export {
  FdkLogoComponent,
} from './lib/logo/logo.component';
export {
  FdkLoadingDotsComponent,
} from './lib/loading-dots/loading-dots.component';
export {
  FdkSpinnerComponent,
} from './lib/spinner/spinner.component';
export {
  FdkSelectComponent,
  type FdkSelectOption,
  type FdkSelectOptionInput,
} from './lib/select/select.component';
export {
  FdkStateViewComponent,
} from './lib/state-view/state-view.component';
export {
  FdkTextareaComponent,
} from './lib/textarea/textarea.component';
export {
  FdkIllustrationComponent,
} from './lib/illustration/illustration.component';
export {
  FDK_ILLUSTRATION_NAMES,
  type FdkIllustrationName,
} from './lib/illustration/illustration.types';
